module.exports = {
      id: "protichinta-logo-usage",
      viewBox: "0 0 190 57.9",
      url: "/" + "svg-sprite-21c17c4d458cf2e2be6dd4c01f9ab03b.svg#protichinta-logo",
      toString: function () {
        return this.url;
      }
    }